<template>
  <div class="depth-label md:text-xs">
    <div v-if="isFirstChannel && (! bottomOutlet || bottomOutlet.part_type == 'accessory')" class="mt-7 diagonal line-to-left text-left">INV. {{ p.depth_label }}</div>
    <div v-else-if="isLastChannel && (! bottomOutlet || bottomOutlet.part_type == 'accessory')" class="mt-7 diagonal line-to-right text-right">INV. {{ p.depth_label }}</div>
    <div v-else-if="p.part_type == 'accessory' && p.type == 'cb'" class="mt-8 diagonal line-to-top text-left">INV. {{ p.depth_label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    'p'                : Object,
    'bottomOutlet'     : [Object, Boolean],
    'isFirstChannel'   : Boolean,
    'isLastChannel'    : Boolean,
  },
}
</script>

<style>
.depth-label {
  font-size: 9px;
  line-height: 9px;
}

@media (min-width: 1024px) {
  .depth-label {
      font-size: 0.75rem;
      line-height: 1rem;
  }
}

/* lines */
.diagonal { position: relative; }
.diagonal::before {
  content: '';
  position: absolute;
  top: -33px;
  width: 1px;
  height:30px;
  background:black;
}

.line-to-left::before {
  left: 10px;
  transform: rotate(-40deg);
}

.line-to-right::before {
  right: 10px;
  transform: rotate(40deg);
}

.line-to-top::before {
  top: -32px;
  height: 25px;
  left: 10px;
}
</style>
